import React from 'react';
import PropTypes from 'prop-types';

export function CellLayout({
  children,
  className = '',
  layout = '', // two-cells, four-cells
  ...rest
}) {
  return (
    <article className={`workplaces-row ${layout} ${className}`} {...rest}>
      {children}
    </article>
  );
}

CellLayout.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  layout: PropTypes.oneOf(['two-cells', 'four-cells']),
};

function Cell({ children, className = '', as = 'div', ...rest }) {
  const Component = as;
  return (
    <Component className={`workplaces-cell ${className}`} {...rest}>
      {children}
    </Component>
  );
}

Cell.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  as: PropTypes.string,
};

CellLayout.Cell = Cell;
